import './styles/ICaptcha.scss';
import { Fragment, useState, useRef, useEffect } from 'react';
import Input from './Input.tsx';

//muis
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

//classes
class CodeMap {
    public target: number = 0;
    public mapped: number = 0;

    constructor(target: number, mapped: number) {
        this.target = target;
        this.mapped = mapped;
    }
}

interface Props {
    captchaVerification : boolean | null,
    SetCaptchaVerification: any,
    codeLength: number,
    className?: string
}

const ICaptcha: React.FC<Props> = ({ captchaVerification, SetCaptchaVerification, codeLength = 4, className }) => {
    //states
    const [targetCode, SetTargetCode] = useState<number[]>([] as number[]);
    const [targetMaps, SetTargetMaps] = useState<CodeMap[]>([] as CodeMap[]);
    const [verificationCode, SetVerificationCode] = useState<string[]>([] as string[]);
    const [verificationMessage, SetVerificationMessage] = useState<string>("Enter the transcribed code below\nto verify you're not a robot.");
    //refs
    const targetCodeRef = useRef<number[]>([] as number[]);
    const targetMapsRef = useRef<CodeMap[]>([] as CodeMap[]);
    const verificationInRef = useRef<any[]>([] as any[]);
    const verificationCodeRef = useRef<string[]>([] as string[]);

    //watchers
    useEffect(() => {
        targetCodeRef.current = GenerateRandomDigits(codeLength);
        SetTargetCode([...targetCodeRef.current]);

        targetMapsRef.current = ShuffleArray(GenerateMapsFromCode(targetCodeRef.current)) as CodeMap[];
        SetTargetMaps([...targetMapsRef.current]);

        verificationInRef.current = [];
        for(let i = 0; i < codeLength; i ++) {
            verificationInRef.current.push(null);
        }
    }, []);

    //exe functions
    const GenerateRandomDigits = (length: number) => {
        const digits = [] as number[];
        for (let i = 0; i < length; i++) {
            digits.push(Math.floor(Math.random() * 10)); // 0–9, repeatable
        }
        return digits;
    }
    const GenerateMapsFromCode = (code: number[]) => {
        const codeMaps = [] as CodeMap[];

        code.map((digit: number) => {
            let isMappeed = false;
            codeMaps.map((cm: CodeMap) => {
                if(!isMappeed && cm.target == digit)
                    isMappeed = true;
            });

            if(!isMappeed)
                codeMaps.push(new CodeMap(digit, GenerateRandomDigits(1)[0]));
        });

        return codeMaps;
    }
    const ShuffleArray = (arr: any[]) => {
        for (let i = arr.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [arr[i], arr[j]] = [arr[j], arr[i]]; // swap
        }
        return arr;
    }
    const GetMappedByTarget = (target: number, targetMaps: CodeMap[]) => {
        let mapped: number = -1;
        targetMaps.map((map: CodeMap) => {
            if(mapped == -1 && map.target == target)
                mapped = map.mapped;
        });
        return mapped;
    }
    const Validate = () => {
        let codeMatches = true;
        targetCodeRef.current.map((c: number, i: number) => {
            if(GetMappedByTarget(c, targetMapsRef.current).toString() != verificationCodeRef.current[i] )
                codeMatches = false;
        });

        if(codeMatches) {
            SetCaptchaVerification(true);
            SetVerificationMessage('Verified successfully.');
        }
        else {
            SetCaptchaVerification(false);
            SetVerificationMessage('Verification failed, wrong code.');
        }
    }

    return (
        <div className={'ICaptcha ' + (className ? className : '')}>
            <div className='ICaptcha-row left'>
                <span className='ICaptcha-title'>Are you a robot?</span>
            </div>
            <div className='ICaptcha-row ex'>
                <div className='ICaptcha-target-panel'>{
                    targetCode.map((digit: number) => {
                        return(
                            <span className='ICaptcha-target-item'>{digit.toString()}</span>
                        )
                    })
                }</div>
                <div className='ICaptcha-map-panel'>
                {
                    targetMaps.map((codeMap: CodeMap) => {
                        return(
                            <div className='ICaptcha-row'>
                                <span className='ICaptcha-map-item'>{codeMap.target}</span>
                                <ArrowForwardIcon />
                                <span className='ICaptcha-map-item'>{codeMap.mapped}</span>
                            </div>
                        )
                    })
                }
                </div>
                <div className='ICaptcha-filter-mask' />
            </div>
            <div className='ICaptcha-row'>
                <span className='ICaptcha-lbl'>{verificationMessage}</span>
            </div>
            <div className='ICaptcha-row'>
                {
                    targetCode.map((code: number, i: number) => {
                        return(
                            <Input
                                ref={(el: any) => verificationInRef.current[i] = el}
                                key={'ICaptcha-in-' + (i).toString()}
                                className={'ICaptcha-verification-in ' + (captchaVerification != null ? (
                                    captchaVerification ?
                                    'green'
                                    :
                                    'red'
                                ): '')}
                                value={verificationCode[i]} SetValue={(value: string) => {verificationCodeRef.current[i] = value; SetVerificationCode([...verificationCodeRef.current])}}
                                type='string' minLength={0} maxLength={1} clearOnFocus={true}
                                onChange={(e: any) => {
                                    if(e.target.value != '') {
                                        //update verification result
                                        verificationCodeRef.current[i] = e.target.value;
                                        SetVerificationCode([...verificationCodeRef.current])

                                        if(i < verificationInRef.current.length - 1)
                                            verificationInRef.current[i + 1].focus();
                                        else
                                            //verification logic here
                                            Validate()
                                    }
                                }}
                            />
                        )
                    })
                }
            </div>
        </div>
    )
}
export default ICaptcha;